<ng-container *ngIf="hasPermissionToView; else noPermission">
  <app-risk-matrix (referenceEvent)="getRiskMatrixRef($event)" [gridData]="chartData" [riskMatrixTitle]="cardTitle"></app-risk-matrix>

  <div class="row mt-2">
    <div class="col-12 col-lg-auto mb-2 mb-lg-0 d-flex align-items-center">
      <sub *ngIf="!filters.date_range || filters.date_range.length == 0 else date_range">A maximum of 3 years of data is displayed.</sub>
      <ng-template #date_range>
        <sub>{{ chartsUtils.getFormattedDateRange(filters.date_range) }}</sub>
      </ng-template>
    </div>
    <div class="col-12 col-lg">
      <div class="d-flex flex-wrap justify-content-lg-end align-items-center">
        <mat-form-field class="chart-filter-field m-1" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Scope</mat-label>
          <mat-select class="form-select" id="hazard_scope" [(ngModel)]="selectedHazardScope" (selectionChange)="onHazardScopeChanged()" matTooltip="Choose whether to count site-level hazards, account-level hazards, or all hazards.">
            <mat-option [value]="hazardScope.scope" *ngFor="let hazardScope of hazardScopes">{{ hazardScope.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="chart-filter-field m-1" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Risk Assessment Type</mat-label>
          <mat-select class="form-select" id="types" [(ngModel)]="selectedRiskAssessmentType" (selectionChange)="onRiskAssessmentTypeChanged()" matTooltip="Select which set of risk assessment results you want to view.">
            <mat-option [value]="riskAssessmentType.type" *ngFor="let riskAssessmentType of riskAssessmentTypes">{{ riskAssessmentType.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #noPermission>
  <div class="alert alert-warning m-3" role="alert">
    You do not have permission to view this chart.
  </div>
</ng-template>


